<template>
    <div>
        <div class="w-full flex justify-between border-b-gray-500 text-gray-500 tracking-widest">
            <div>
                Address 
            </div>
            <div><span class="text-3xl text-yellow-600" v-if="hasUnsavedChanges">•</span></div>
        </div>
        <div v-if="isEditable" class="flex justify-between items-center pl-2">
            <input @change="updateAddress" type="text" v-model="address" class="border p-1 m-1 w-full">
        </div>
        <div class="pl-2" v-else>
            <div class="p-1">
                {{ calculatedAddress }}
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, defineProps, defineEmits, computed, watch } from 'vue';

const props = defineProps([
    'company',
    'isEditable'
])

const emit = defineEmits(['update-address'])

const calculatedAddress = computed(() => {
    if(props.company) {
        return props.company.address
    } else {
        return null
    }
})

const address = ref(props.company ? props.company.address : null)

const hasUnsavedChanges = computed(() => {
    return props.company && props.company.original_address != props.company.address
})

watch(calculatedAddress, () => {
    address.value = calculatedAddress.value
})

function updateAddress(){
    emit('update-address', address.value)
}


</script>